/* @flow */
export const Experiments = {
  TEST: {
    // needed for Experimentation-test
    apiKey: '1080.apr.web.unit_test',
    validVariants: ['control', 'someValid'],
  },
  CHAT_DEPROXY: {
    apiKey: '2018.feb.web.chat_stream_deproxy',
    validVariants: ['control', 'deproxy'],
  },
  // RESOLVE(Felix) control chosen https://experiments.remind.com/experiment/2017.jul.web.new_join_pdf
  NEW_PDF: {
    apiKey: '2017.jul.web.new_join_pdf',
    validVariants: ['control', 'new_pdf'],
  },
  INDIVIDUAL_PLAN: {
    apiKey: '2018.dec.canada_individual_plans',
    validVariants: ['control', 'individual_plan'],
  },
};
